import styled from 'styled-components';

export default {
  Container: styled.div<{ isHidden: boolean }>`
    display: ${(props) => (props.isHidden ? 'none' : 'flex')};
    flex-grow: 1;
    height: 100%;
  `,
  Overlay: styled.div<any>`
    flex-grow: 1;
  `,

  Layout: styled.div<any>`
    position: relative;
    height: 100%;
    overflow: hidden;

    @media screen and (max-width: 700px) {
      position: absolute;
      height: 100%;
      width: 100%;
      top: 0;
      left: 0;
    }
  `,

  Canvas: styled.canvas`
    position: absolute;
    left: 0;
    top: 0;
  `,
};
